import React, { useState, useEffect } from 'react';
import { Grid, FormControlLabel, Switch, Typography } from '@mui/material';

const SignUpOptions = ({
  formData,
  handleNestedChange = () => {
    console.log('handleNestedChange not provided');
  },
  tempTheme,
}) => {
  const [newVals, setNewVals] = useState(formData.signUpOptions);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleDebouncedChange = debounce((name, value) => {
    setNewVals((prevVals) => ({
      ...prevVals,
      [name]: value,
    }));
  }, 3000);

  const handleInputChange = (event) => {
    const { name, checked } = event.target;
    handleNestedChange('signUpOptions', name, checked);
    handleDebouncedChange(name, checked);
  };

  // useEffect(() => {
  //   console.log('New Values:', newVals);
  // }, [newVals]);

  return (
    <>
      <Typography
        variant="h6"
        sx={{ marginTop: 4 }}
      >
        Sign Up Options
      </Typography>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.signUpOptions.enableSignUp}
                name="enableSignUp"
                onChange={handleInputChange}
                sx={tempTheme} // Apply tempTheme styles
              />
            }
            label="Enable User Sign Up"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.signUpOptions.hideEmail}
                name="hideEmail"
                onChange={handleInputChange}
                sx={tempTheme} // Apply tempTheme styles
              />
            }
            label="Hide Email in Sign Up"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.signUpOptions.hidePhone}
                name="hidePhone"
                onChange={handleInputChange}
                sx={tempTheme} // Apply tempTheme styles
              />
            }
            label="Hide Phone in Sign Up"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.signUpOptions.enableCodeBasedLogin}
                name="enableCodeBasedLogin"
                onChange={handleInputChange}
                sx={tempTheme} // Apply tempTheme styles
              />
            }
            label="Enable Code-Based Login"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.signUpOptions.requirePasswordExpiration}
                name="requirePasswordExpiration"
                onChange={handleInputChange}
                sx={tempTheme} // Apply tempTheme styles
              />
            }
            label="Require password expiration for admin portal users"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SignUpOptions;
